import React from 'react';
import { Link } from 'react-router-dom';

import { Button, Card, Col, Collapse, Input, Row, Tooltip, Typography } from 'antd';
import { Icon } from '@eduzz/ui-antd-theme';

import PermissionHide from '../PermissionHide/index';

type FooterProps = {
  hideQuickHelp?: boolean;
  className?: string;
};

const Footer = ({ hideQuickHelp, className }: FooterProps) => {
  const [show, toggle] = React.useState(false);

  const onClick = () => {
    toggle(!show);
    localStorage.setItem('helper-footer', `${!show}`);
  };

  return (
    <footer id='main-footer' className={['mx-auto min-w-full py-4 tracking-normal', className].filter(Boolean).join(' ')}>
      {!hideQuickHelp && (
        <div className='flex justify-center'>
          <Tooltip title='Ajuda Rápida'>
            <Button
              type='text'
              size='large'
              className='rounded-full'
              onClick={onClick}
              icon={show ? <Icon.ChevronUp color='gray' size={50}/> : <Icon.CircleHelp color='gray' size={50}/>}
              aria-label={show ? 'Fechar ajuda rápida' : 'Abrir ajuda rápida'}
            />
          </Tooltip>
        </div>
      )}

      <Collapse activeKey={show ? ['1'] : []} ghost>
        <Collapse.Panel key='1' header={null} showArrow={false}>
          <Card>
            <Row gutter={16}>
              <Col xs={24} sm={12}>
                <Typography.Title level={4}>Ajuda rápida com artigos e tutoriais</Typography.Title>
                <Typography.Text type='secondary'>Descubra como fazer qualquer coisa na Eduzz.</Typography.Text>
                <div className='hidden sm:block'>
                  <PermissionHide action={'myeduzz:ajuda:visualizar'}>
                    <Link className='mt-3 block' to='/producer/help'>
                      <Typography.Text>Ir para Central de Ajuda</Typography.Text>
                    </Link>
                  </PermissionHide>
                </div>
              </Col>
              <Col xs={24} sm={12}>
                <form action='https://ajuda.eduzz.com/hc/pt-br/search' method='GET' target='_blank'>
                  <input type='hidden' name='utm_source' value='myeduzz_footer' />
                  <input type='hidden' name='utf8' value='✓' />
                  <Input
                    name='query'
                    type='search'
                    placeholder='como criar um produto físico'
                    prefix={<Icon.Search  />}
                  />
                  <Button className='mt-3!' htmlType='submit'>
                    Pesquisar
                  </Button>
                </form>
              </Col>
            </Row>
          </Card>
        </Collapse.Panel>
      </Collapse>
      <Typography.Paragraph type='secondary' className='text-center'>
        {new Date().getFullYear()} © Eduzz – Todos os direitos reservados
      </Typography.Paragraph>
    </footer>
  );
};

export default Footer;
